export const REHABPATH_LABEL = 'RehabPath Inc'

export const RECOVERY_URL = 'https://recovery.com'
export const RECOVERY_LABEL = 'Recovery.com'
